<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2,10C2,10,2,11,2,11C2,11,2,11.43,2,12C2,12,2,12.99,2,12.99C2,13.99,2,15,2,15C2,15.55,2.45,16,3,16C3,16,6,16,6,16C6,16,6,11,6,11C6,11,10,11,10,11C10,11,10,16,10,16C10,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,10,14,10C14,10,8,4,8,4C8,4,2,10,2,10C2,10,2,10,2,10ZM15.71,7.29C15.71,7.29,14,5.59,14,5.59C14,5.59,14,2,14,2C14,1.45,13.55,1,13,1C12.45,1,12,1.45,12,2C12,2,12,3.59,12,3.59C12,3.59,8.71,0.29,8.71,0.29C8.53,0.11,8.28,0,8,0C7.72,0,7.47,0.11,7.29,0.29C7.29,0.29,0.29,7.29,0.29,7.29C0.11,7.47,0,7.72,0,8C0,8.55,0.45,9,1,9C1.28,9,1.53,8.89,1.71,8.71C1.71,8.71,8,2.41,8,2.41C8,2.41,14.29,8.7,14.29,8.7C14.47,8.89,14.72,9,15,9C15.55,9,16,8.55,16,8C16,7.72,15.89,7.47,15.71,7.29C15.71,7.29,15.71,7.29,15.71,7.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Home',
} as DefineComponent
</script>
